var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertisement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.61 6.37a3.19 3.19 0 0 0-3-.35 21.81 21.81 0 0 1-7.9 1.59H12.8a3.21 3.21 0 0 0-3.2 3.2v4.55a3.2 3.2 0 0 0 3.2 3.2h1.06l.72 2.51a4.29 4.29 0 0 0 4.1 3.09 2.2 2.2 0 0 0 1.87-.85 2.14 2.14 0 0 0 .35-1.87l-.82-2.87a20.19 20.19 0 0 1 7 1.35 4.78 4.78 0 0 0 1.74.44 3.2 3.2 0 0 0 3.2-3.2V9a3.2 3.2 0 0 0-1.41-2.63zM18.68 22a2.14 2.14 0 0 1-2.05-1.55l-.55-1.92h1.78l1 3.47zm11.19-4.86a1.06 1.06 0 0 1-.46.88c-.52.36-1.06.09-1.57-.11a22.33 22.33 0 0 0-8.09-1.51H12.8a1.07 1.07 0 0 1-1.07-1.07v-4.52a1.07 1.07 0 0 1 1.07-1.06h6.95A22.3 22.3 0 0 0 25.6 9v4.91a1.07 1.07 0 0 0 2.13 0V8.27l.69-.27a1.07 1.07 0 0 1 1.45 1z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.53 22.4a1.07 1.07 0 0 0-1.07 1.07v3.2a3.2 3.2 0 0 1-3.2 3.2H5.33a3.2 3.2 0 0 1-3.2-3.2V5.33a3.2 3.2 0 0 1 3.2-3.2h14.94A3.21 3.21 0 0 1 23 3.73a1.07 1.07 0 1 0 1.85-1.07A5.35 5.35 0 0 0 20.27 0H5.33A5.33 5.33 0 0 0 0 5.33v21.34A5.33 5.33 0 0 0 5.33 32h14.94a5.34 5.34 0 0 0 5.33-5.33v-3.2a1.07 1.07 0 0 0-1.07-1.07z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.93 27.73a1.07 1.07 0 1 0 0-2.13h-4.26a1.07 1.07 0 1 0 0 2.13zM5.33 4.27a1.07 1.07 0 0 0 0 2.13h2.14a1.07 1.07 0 0 0 0-2.13z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertisement);
export default __webpack_public_path__ + "static/media/advertisement.1ab1f1a73a490ba2905afb5ef670cbfa.svg";
export { ForwardRef as ReactComponent };